var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "field-pt-checkbox",
      class: {
        "field-pt-checkbox__active": _vm.checked || _vm.indeterminate,
        "field-pt-checkbox__disabled": _vm.disabled,
      },
      attrs: { "data-check-status": _vm.checkboxIcon },
      on: { click: _vm.onClick },
    },
    [_c("PtIcon", { attrs: { icon: _vm.checkboxIcon } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }